import { Component, OnInit } from '@angular/core';
import { MenuController } from '@ionic/angular';
import { HttpClient } from '@angular/common/http';
import { filter, map, pluck } from 'rxjs/operators';
import { VtigerService } from './api/api';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { StorageService } from 'src/services/storage.service';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit{
  sessionid?:string;
  appPages?:any;
  modules?:any;
  labels?:any;
  moduleLabels?:any;
  menuLoading = true;
  public firstname?: any;
  public lastname?: any;
  public email?: any;
  public usuario: any;
public label : any;

message$: Observable<string>;
  constructor(private storageService: StorageService,private menu: MenuController,private http : HttpClient, private ws : VtigerService, public route: ActivatedRoute,public router: Router) {
    this.initializeMenu();
  }

  async ngOnInit() {
    console.log(this.router.url)
    this.cargarUsuarioDesdeCache();
    if(localStorage.getItem('sessionid') && !this.usuario) {
      await this.cargarUsuarioRemoto();
    }

     this.message$ = this.storageService.storageChange$.pipe(
      filter(({ storageArea }) => storageArea === "sessionStorage"),
      filter(({ key }) => key === "message"),
      pluck("value")
    );

  }

  tieneSesion(){
  
    if(localStorage.getItem('sessionid')) {
    return true;
    }else{
    return false;
    }
  }

 
  async getRecord(id: string) {

    var record = await this.ws.getUsers(id)
    return record['result']
  }
  
  initializeMenu() {
    this.menu.enable(true, 'first');
    this.http.get('assets/json/labels.json').pipe(
      map((res:any) => {
        return res;
      })
    ).subscribe((val) => {
      this.labels = val;
      this.http.get('assets/json/module.json').pipe(
        map((res:any) => {
          return res;
        })
      ).subscribe((moduleConfig) => {
        this.moduleLabels = moduleConfig.labels || {};
        this.hidratarMenuDesdeCache();
        this.onMenuWillOpen();
      });
    });
  }

  async onMenuWillOpen(){
      if (!this.labels) return;
      this.menuLoading = true;
      this.sessionid = localStorage.getItem('sessionid');
      if(!this.sessionid){
        localStorage.clear();
        this.appPages = this.labels.unlogged; 
        this.modules = null;
        this.menuLoading = false;
      }else
      await this.ws.testSession().then(async (res:any) => {
        if(!res || !res.success){
          localStorage.clear();
          this.modules = null;
          this.onMenuWillOpen();
          this.router.navigate(['/login']);
        }else{
          if(!this.modules){
            this.appPages = this.labels.logged;
            const cachedModuleModels = localStorage.getItem('modulemodels');
            const cachedModuleModelsVersion = localStorage.getItem('modulemodelsVersion');
            if (cachedModuleModels && cachedModuleModelsVersion === String(environment.versionDate)) {
              this.modules = this.buildMenuModules(JSON.parse(cachedModuleModels), this.moduleLabels || {});
            }
            if (!this.modules) await this.ws.describeModules().then((response:any) =>{
                if(response.success){
                  localStorage.setItem('modulemodels', JSON.stringify(response.result));
                  localStorage.setItem('modulemodelsVersion', String(environment.versionDate));
                  this.modules = this.buildMenuModules(response.result, response.labels);
                }
              }
            );
          }
        }
      }).finally(() => this.menuLoading = false);
  }

  hidratarMenuDesdeCache() {
    this.sessionid = localStorage.getItem('sessionid');
    this.appPages = this.sessionid ? this.labels.logged : this.labels.unlogged;
    if (!this.sessionid) {
      this.menuLoading = false;
      return;
    }

    const cachedModuleModels = localStorage.getItem('modulemodels');
    const cachedModuleModelsVersion = localStorage.getItem('modulemodelsVersion');
    if (cachedModuleModels && cachedModuleModelsVersion === String(environment.versionDate)) {
      this.modules = this.buildMenuModules(JSON.parse(cachedModuleModels), this.moduleLabels || {});
      this.menuLoading = false;
    }
  }

  buildMenuModules(models: any, labels: any) {
    var modulos = Array();
    for(var m in models){
      var l = labels[m];
      if(!l) continue;
      l.name = m;
      modulos.push(l);
    }
    return modulos;
  }

  cargarUsuarioDesdeCache() {
    const cached = localStorage.getItem('usuarioLogueado');
    if (!cached) return;

    try {
      const usuarioLogueado = JSON.parse(cached);
      this.usuario = usuarioLogueado?.user || usuarioLogueado?.contact || usuarioLogueado;
      this.aplicarUsuario(this.usuario);
    } catch (error) {
      console.error('No se pudo leer usuario cacheado', error);
    }
  }

  async cargarUsuarioRemoto() {
    this.usuario = await this.getRecord(localStorage.getItem('contactid'));
    this.aplicarUsuario(this.usuario);
  }

  aplicarUsuario(usuario: any) {
    if (usuario != undefined) {
      this.firstname = usuario['firstname']
      this.lastname = usuario['lastname']
      this.email = usuario['email']
    }
  }

  logout(){
    localStorage.clear();
    this.modules = null;
    this.onMenuWillOpen();
    
    this.router.navigate(['/login']);
    
  }
}
